<template>
  <div class="otp-verify-card">
    <div class="d-flex flex-column" style="gap: 1rem;">
      <FormGroup :error-container="errorContainer" label="Email address" name="email" :floating="true">
        <input :id="id" ref="input" v-model="form.email" :readonly="meta.loading || meta.codeSent"
               class="form-control" name="email"
               placeholder=" " required type="email"
               @blur="form.email = form.email.trim()"
               @keyup.enter="sendCode"
        />
      </FormGroup>

      <TimeCountdown
        v-if="meta.preventResend"
        :disabled="meta.loading"
        :from="60"
        class="fm-resend-hint"
        request-change-text="Change Email"
        @requestChange="onRequestEmailChange"
        @resend="sendCode"
      />

      <FormGroup v-if="meta.codeSent" :error-container="errorContainer" label="Verification Code" name="code" :floating="true">
        <input :id="codeId" v-model="form.code" :readonly="meta.loading"
               class="form-control otp-code-input"
               name="code" required type="text"
               maxlength="6" placeholder=" "
               autocomplete="one-time-code"/>
      </FormGroup>

      <div class="d-flex gap-2 flex-wrap">
        <button v-if="!meta.codeSent" :disabled="meta.loading"
                class="btn-fm btn-fm-primary" type="button" @click="sendCode">
          <SpinKit v-if="meta.loading" :loading="true"/>
          <span v-else>Send Code</span>
        </button>
        <button v-if="meta.codeSent" :disabled="meta.loading"
                class="btn-fm btn-fm-primary" type="button" @click="verifyCode">
          <SpinKit v-if="meta.loading" :loading="true"/>
          <span v-else>Verify Code</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TimeCountdown from '@modules/guest/new-applicant/components/steps/ContactVerification/components/TimeCountdown';
import SpinKit from '@components/common/SpinKit';
import FormGroup from '@modules/shared/components/form/FormGroup';
import ServerErrorMixin from '@modules/shared/mixins/ServerErrorMixin';
import store from '@modules/guest/new-applicant/store/store';
import {NEW_APPLICATION} from '@store/constants';
import {sendAccessOTPCode, verifyAccessOTPCode} from '@modules/guest/new-applicant/NewApplicationService';
import {Str} from '@/utilities/random';

export default {
  name: 'EmailVerification',
  props: ['errorContainer'],
  mixins: [ServerErrorMixin],
  components: {
    TimeCountdown,
    SpinKit,
    FormGroup,
  },
  computed: {
    code: () => store.state[NEW_APPLICATION.MODULE_NAME].code,
  },
  data() {
    return {
      id: Str.random({length: 6, unique: true}),
      codeId: Str.random({length: 6, unique: true}),
      form: {
        email: '',
        code: '',
      },
      meta: {
        loading: false,
        codeSent: false,
        preventResend: false,
      },
    };
  },
  methods: {
    validate() {
      this.setErrorByKey('email');

      if (!this.$refs.input.validity.valid) {
        this.setErrorByKey('email', 'Email is invalid');
      }
    },
    async sendCode() {
      if (this.meta.loading) {
        return;
      }

      this.validate();

      if (this.hasError('email')) {
        return;
      }

      this.meta.loading = true;
      const payload = {email: this.form.email};

      try {
        await sendAccessOTPCode(this.code, payload);

        this.meta.codeSent = true;
        this.meta.preventResend = true;
      } catch (e) {
        await this.handleServerError(e);
      } finally {
        this.meta.loading = false;
      }
    },
    async verifyCode() {
      if (this.meta.loading) {
        return;
      }

      const error = this.form.code.trim().length === 0 ?
        'Email verification code is required' :
        null;

      this.setErrorByKey('code', error);

      if (this.hasError('code')) {
        return;
      }

      const payload = this.form;
      this.meta.loading = true;

      try {
        await verifyAccessOTPCode(this.code, payload);

        this.$emit('verified');

        this.meta.codeSent = false;
        this.meta.preventResend = false;
        this.form.code = '';
      } catch (e) {
        await this.handleServerError(e);
      } finally {
        this.meta.loading = false;
      }
    },
    onTimeout() {
      this.meta.preventResend = false;
    },
    onRequestEmailChange() {
      this.meta.codeSent = false;
      this.meta.preventResend = false;
    },
  },
};
</script>
